import { useTenantSubscriptionQuery } from "@/actions/tenantSubscription.actions";
import { getSubscriptionBannerMessage } from "@/lib/tenantSubscription";
import { Alert } from "antd";
import { Clock3 } from "lucide-react";
import { useEffect, useState } from "react";

/** Shows a live trial or renewal reminder below the authenticated navbar on every CRM page. */
export const SubscriptionBanner = () => {
  const query = useTenantSubscriptionQuery();
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(timer);
  }, []);
  const message = query.data ? getSubscriptionBannerMessage(query.data, now) : null;
  if (!message) return null;
  return <div className="px-4 pt-3 pb-2" role="status" aria-live="polite">
    <Alert type="warning" showIcon icon={<Clock3 size={18} />} message={message} />
  </div>;
};
